import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import CaseStudies from './components/CaseStudies';
import About from './components/About';
import EcosystemClean from './components/EcosystemClean';
import ThoughtLeadership from './components/ThoughtLeadership';
import Contact from './components/Contact';

const Home = () => {
  return (
    <div>
      <Header />
      <main>
        <div id="hero">
          <Hero />
        </div>
        <div id="case-studies">
          <CaseStudies />
        </div>
        <div id="about">
          <About />
        </div>
        <div id="ecosystem">
          <EcosystemClean />
        </div>
        <div id="thought">
          <ThoughtLeadership />
        </div>
        <div id="contact">
          <Contact />
        </div>
      </main>
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;